import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t, language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        {/* Title */}
        <h1
          className={`text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('aboutTitle')}
        </h1>

        {/* Content */}
        <div className="space-y-6 text-gray-700 leading-relaxed text-center">
          <p
            className={`text-lg md:text-xl font-medium text-gray-900 transition-all duration-1000 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            {t('aboutIntro')}
          </p>

          <div className="space-y-4">
            <p
              className={`transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP1')}
            </p>

            <p
              className={`transition-all duration-1000 delay-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP2')}
            </p>

            <p
              className={`transition-all duration-1000 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP3')}
            </p>

            <p
              className={`transition-all duration-1000 delay-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP4')}
            </p>

            <p
              className={`transition-all duration-1000 delay-600 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP5')}
            </p>

            <p
              className={`transition-all duration-1000 delay-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP6')}
            </p>

            <p
              className={`transition-all duration-1000 delay-800 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('aboutP7')}
            </p>
          </div>

          {/* External Link */}
          <div
            className={`mt-8 p-6 bg-gray-100 rounded-lg transition-all duration-1000 delay-900 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <a
              href="https://stt.fi/ajankohtaista/jussi-nukari-elakkeelle/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-900 hover:text-gray-600 font-medium underline transition-colors"
            >
              {language === 'fi' ? 'STT-Lehtikuva Blogi' : 'STT-Lehtikuva Blog'} →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;